import { Controller } from 'stimulus'
import { Swiper } from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

export default class extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 4000,
      },
      speed: 800,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        prevEl: '.ty-swiper-button-prev',
        nextEl: '.ty-swiper-button-next',
      },
    })
    this.swiper.slideToLoop(0)
  }

  disconnect() {
    this.swiper.destroy()
  }
}
